import React, { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import "./table.css";

export default function BaseTable({
  columns,
  data,
  rowKey = "id",
  expandable,
}) {
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleRow = (row, index) => {
    setExpandedRow(expandedRow === row[rowKey] ? null : row[rowKey]);
  };

  return (
    <div className="table-container">
      <div className="table-scrollable">
        <table className="table-base table-hover">
          <thead className="table-header">
            <tr>
              {expandable && <th className="expand-col"></th>}

              {columns.map((col, index) => (
                <th key={index} className={col.className || ""}>
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, index) => {
              const isExpanded = expandedRow === row[rowKey];

              return (
                <React.Fragment key={`${row[rowKey]}-${index}`}>
                  <tr className={`table-row ${isExpanded ? "active" : ""}`}>
                    
                    {/* 🔽 Expand Icon */}
                    {expandable && (
                      <td
                        className="expand-cell"
                        onClick={() => toggleRow(row, index)}
                      >
                        {isExpanded ? (
                          <ChevronDown size={18} />
                        ) : (
                          <ChevronRight size={18} />
                        )}
                      </td>
                    )}

                    {columns.map((col, index) => (
                      <td
                        key={`${row[rowKey]}-${index}`}
                        className={`table-cell ${col.className || ""}`}
                      >
                        {col.render
                          ? col.render(row[col.dataIndex], row)
                          : row[col.dataIndex]}
                      </td>
                    ))}
                  </tr>

                  {/* 🔽 Expanded */}
                  {expandable && isExpanded && (
                    <tr className="expanded-row">
                      <td colSpan={columns.length + 1}>
                        {expandable.expandedRowRender(row)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}